export default __webpack_public_path__ + "pdf/loghub_sample_calibration_protocol.5781a512.pdf";